(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const button=event.target.closest('.hiirad-ticker__pause');
  if(!button)return;
  const ticker=button.closest('.hiirad-ticker');
  const paused=ticker.dataset.paused!=='true';
  ticker.dataset.paused=String(paused);
  button.setAttribute('aria-pressed',String(paused));
  button.querySelector('span').textContent=paused?'▶':'❚❚';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initCatalogs(root = document) {
    root.querySelectorAll('[data-home-catalog]').forEach(section => {
      if (section.dataset.catalogReady) return;
      section.dataset.catalogReady = 'true';
      const grid = section.querySelector('.product-grid');
      const controls = section.querySelector('[data-catalog-controls]');
      const status = section.querySelector('[data-catalog-count]');
      let next = section.querySelector('[data-catalog-next]');
      const limit = Number(section.dataset.limit);
      let busy = false;
      let failed = false;
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !failed) load();
      }, {rootMargin: '400px'}) : null;
      async function load(event) {
        if (failed) return;
        if (event) event.preventDefault();
        if (busy || !next || grid.children.length >= limit) return;
        busy = true;
        observer?.unobserve(controls);
        const label = next.textContent;
        next.setAttribute('aria-disabled', 'true');
        next.textContent = next.dataset.loadingLabel;
        grid.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(next.href, window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('Invalid origin');
          url.searchParams.set('section_id', section.dataset.id);
          const response = await fetch(url, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Products could not load');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = parsed.querySelector('[data-home-catalog]');
          if (!incoming) throw new Error('Missing products');
          const items = [...incoming.querySelector('.product-grid').children];
          if (!items.length) throw new Error('Empty products');
          const known = new Set([...grid.children].map(item => item.id));
          items.filter(item => !known.has(item.id)).slice(0, limit - grid.children.length).forEach(item => {
            [item, ...item.querySelectorAll('.scroll-trigger')].forEach(element => {
              element.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
              element.removeAttribute('data-cascade');
            });
            grid.appendChild(item);
          });
          status.textContent = status.dataset.countLabel.replace('[shown]', grid.children.length);
          const incomingNext = incoming.querySelector('[data-catalog-next]');
          if (incomingNext && grid.children.length < limit) {
            next.href = incomingNext.href;
          } else {
            next.remove();
            next = null;
            observer?.disconnect();
          }
        } catch (error) {
          failed = true;
          observer?.disconnect();
        } finally {
          grid.removeAttribute('aria-busy');
          if (next) {
            next.textContent = label;
            next.removeAttribute('aria-disabled');
          }
          busy = false;
          if (next && !failed) observer?.observe(controls);
        }
      }
      if (next) {
        next.addEventListener('click', load);
        observer?.observe(controls);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCatalogs());
  else initCatalogs();
  document.addEventListener('shopify:section:load', event => initCatalogs(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiirad-spotlight-deals"] && !Shopify.designMode) return;
  try {
    
function initHiiradRotation(){
 document.querySelectorAll('.hm--spotlight').forEach(section=>{
 const hero=section.querySelector('.hm__hero'), image=hero?.querySelector('.hm__heroimg'), link=hero?.querySelector('.hm__heroText a'), heading=hero?.querySelector('h2');
 if(!image||!link||hero.dataset.rotationReady)return;
 const slideTemplate=section.querySelector('[data-spotlight-slides]');
 const slides=Array.from(slideTemplate?.content.querySelectorAll('a')||[]).map(a=>({image:a.querySelector('img'),url:a.href,title:a.dataset.slideTitle})).filter(s=>s.image);
 if(slides.length<2)return;
 hero.dataset.rotationReady='true';let index=-1,paused=matchMedia('(prefers-reduced-motion: reduce)').matches,hover=false;
 const controls=document.createElement('div');controls.style.cssText='position:absolute;bottom:8px;right:8px;z-index:4;display:flex;gap:5px';
 function show(direction){index=(index+direction+slides.length)%slides.length;const s=slides[index];image.removeAttribute('srcset');image.src=s.image.currentSrc||s.image.src;image.alt=s.title;link.href=s.url;if(heading)heading.textContent=s.title;}
 [['‹','Previous slide',()=>show(-1)],['Ⅱ','Pause slideshow',b=>{paused=!paused;b.textContent=paused?'▶':'Ⅱ';b.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow')}],['›','Next slide',()=>show(1)]].forEach(([text,label,action])=>{const b=document.createElement('button');b.type='button';b.textContent=text;b.setAttribute('aria-label',label);b.style.cssText='background:#fff;color:#2C5030;border:0;border-radius:50%;width:32px;height:32px;cursor:pointer';b.addEventListener('click',()=>action(b));controls.append(b)});
 show(1);
 hero.append(controls);hero.addEventListener('mouseenter',()=>hover=true);hero.addEventListener('mouseleave',()=>hover=false);hero.addEventListener('focusin',()=>hover=true);hero.addEventListener('focusout',()=>hover=false);
 const timer=setInterval(()=>{if(!hero.isConnected){clearInterval(timer);return}if(!paused&&!hover&&!document.hidden)show(1)},5000);
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initHiiradRotation);else initHiiradRotation();
document.addEventListener('shopify:section:load',initHiiradRotation);

  } catch(e) { console.error(e); }
})();
})();
